import { render, staticRenderFns } from "./acu2.vue?vue&type=template&id=1ab2a092&scoped=true&"
import script from "./acu2.vue?vue&type=script&lang=js&"
export * from "./acu2.vue?vue&type=script&lang=js&"
import style0 from "./acu2.vue?vue&type=style&index=0&id=1ab2a092&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab2a092",
  null
  
)

export default component.exports